import type { IconData } from '@stacksjs/iconify-core'

export const stamp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18 18v-2H2v2zM7 14V9a5 5 0 1 1 6 0v5h5a2 2 0 0 1 2 2v4H0v-4a2 2 0 0 1 2-2zm4 0V8.001l.799-.6a3 3 0 1 0-3.598 0l.799.6V14z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default stamp
